// src/components/decor/CyberCorner.jsx
import { useEffect, useState } from "react";
import "../../styles/cyber-corner.css";

const CyberCorner = () => {
  const [bottomOffset, setBottomOffset] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      const footer = document.querySelector(".site-footer");
      if (!footer) return;

      const footerRect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const overlap = Math.max(0, viewportHeight - footerRect.top);
      setBottomOffset(overlap);
    };

    window.addEventListener("scroll", updatePosition, { passive: true });
    window.addEventListener("resize", updatePosition);
    updatePosition();

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  return (
    <div
      className="cyber-corner"
      style={{ bottom: `${bottomOffset}px` }}
      aria-hidden="true"
    >
      <div className="cyber-corner__grid" />
      <div className="cyber-corner__scanlines" />

      <div className="cyber-corner__nodes">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="cyber-corner__beams">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

export default CyberCorner;